import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Credentials } from '../credentials';
import { UiService } from 'core/services/ui.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { JwtService } from 'core/services/jwt.service';

@Component({
  selector: 'lms-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('loginForm', { static: false }) public loginForm: NgForm;
  formErrorMessage: String = null;
  username: String;
  password: String;
  rememberMe: String;

  embedLogin = (environment.ft as any).enableLogin === 'embed';
  loginUrl: SafeUrl;

  messageListener: any = null;

  constructor(
    public authService: AuthService,
    public sanitizer: DomSanitizer,
    public uiService: UiService,
    public router: Router,
    public jwtService: JwtService
  ) {}

  ngOnInit() {
    // reset login status
    this.authService.logout();
    // eslint-disable-next-line
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('sid', environment.SERVICE_ID);
    this.loginUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.SERVICES_URL}/login?${urlParams.toString()}`
    );
  }

  onLoginLoad(e) {
    const iframe = e.target; //this.$refs.loginFrame;
    iframe.contentWindow.postMessage(
      { type: 'embedLogin', data: { serviceId: environment.SERVICE_ID } },
      environment.SERVICES_URL
    );
    // eslint-disable-next-line
    window.addEventListener('message', (e) => this.onEmbedLoginMessage(e));
  }

  onEmbedLoginMessage(e) {
    if (!e.data || !e.data.type || e.data.type !== 'embedLogin') {
      return;
    }
    e.data.type = null;
    if (e.data.data.token) {
      this.jwtService.saveSessionToken(e.data.data.token);
      this.uiService.setLandingUrl();
    }
  }

  get submitDisabled() {
    return !this.username || !this.password;
  }

  onSubmit() {
    this.authService
      .authenticate(new Credentials(this.username, this.password))
      .then((result) => {
        if (result.valid) {
          this.uiService.setLandingUrl();
        } else {
          // eslint-disable-next-line
          console.error('Authentication result', result);
          this.formErrorMessage = 'System error, try it later';
        }
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error('Error: ' + JSON.stringify(error, null, 2));
        this.formErrorMessage =
          error.data && error.data.message ? error.data.message : error.data ? error.data : error.serverMessage;
        this.loginForm.resetForm({ username: this.username, password: this.password });
      });
  }
}
